import { render, staticRenderFns } from "./formInformacionComercial.vue?vue&type=template&id=2d8f72d4&scoped=true"
import script from "./formInformacionComercial.vue?vue&type=script&lang=js"
export * from "./formInformacionComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f72d4",
  null
  
)

export default component.exports